import { RefObject, useEffect, useState } from "react";
import { mediaQueries } from "../style";

export type CoordData = {
  position: "absolute";
  top: number;
  left: number;
  width?: number;
};

type PortalDropdownCoordOptions = {
  menuRef?: RefObject<HTMLElement>;
  isMenuOpen: boolean;
  renderInPortal: boolean;
  includeWidth?: boolean;
};

type PortalDropdownCoordHook = {
  coords: CoordData;
  updateCoords: () => void;
  shouldUseCoords: boolean;
};

export function usePortalDropdownCoords({
  menuRef,
  isMenuOpen,
  renderInPortal = false,
  includeWidth = true,
}: PortalDropdownCoordOptions): PortalDropdownCoordHook {
  // eslint-disable-next-line @typescript-eslint/prefer-as-const
  const position: "absolute" = "absolute";
  const [coords, setCoords] = useState({
    position,
    top: 0,
    left: 0,
  });
  const isMediumBreakpoint = mediaQueries.mediumMin.useMatchesBreakpoint();

  function updateCoords() {
    const rect = menuRef?.current?.getBoundingClientRect();

    if (rect && isMenuOpen) {
      const updatedCoords: CoordData = {
        ...coords,
        left: rect.x,
        top: rect.y + window.scrollY + rect.height,
      };

      if (includeWidth) {
        updatedCoords.width = rect.width;
      }

      setCoords(updatedCoords);
    }
  }

  useEffect(() => {
    const rect = menuRef && menuRef.current && menuRef.current.getBoundingClientRect();
    if (rect && isMenuOpen) {
      updateCoords();
    }
  }, [menuRef, isMenuOpen, setCoords]);

  return {
    coords,
    updateCoords,
    shouldUseCoords: renderInPortal && isMediumBreakpoint,
  };
}
